import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material"
import { Delete as DeleteIcon } from "@mui/icons-material"
import { useTranslation } from "react-i18next"

export default function ConfirmDeleteDialog({ open, onClose, onConfirm, couponCode, saving = false, error }) {
    const { t } = useTranslation()

    return (
        <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth aria-labelledby="coupon-delete-title">
            <DialogTitle id="coupon-delete-title" sx={{ display: "flex", alignItems: "center" }}>
                <DeleteIcon sx={{ mr: 1, color: "error.main" }} />
                {t("ConfirmDelete")}
            </DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
                <Typography>
                    {t("ConfirmDeleteDesc")} "{couponCode}"?
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {t("ConfirmDeleteAction")}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
                <Button onClick={onClose} disabled={saving}>{t("Cancel")}</Button>
                <Button onClick={onConfirm} disabled={saving} variant="contained" color="error">
                    {t(saving ? "CouponDeleting" : "Delete")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
